import NameForm from 'components/NameForm/NameFormComponent';
import NameFormContainer from 'components/NameForm/NameFormContainer';

export { default as NameForm } from 'components/NameForm/NameFormComponent';
export { default as NameFormContainer } from 'components/NameForm/NameFormContainer';

export default {
  NameForm,
  NameFormContainer,
};
